import type {$Fetch} from "nitropack";

export interface ExportMyDataResponse {
    metadata: {
        user_id: string;
        exported_at: string;
        export_version: string;
    };
    experiences: any[];
    invoices: any[];
}

export const ExportRepository = (client: $Fetch) => ({
    downloadMyData: () => {
        return client('/v2/export/my-data', {
            method: 'GET',
        }) as Promise<ExportMyDataResponse>;
    },
});
